import { ApiOptions } from '../../api-options.decorator';
import { ParamsAdapter } from '../../params.adapter';
import { RoleCapacity } from '../../role-capacity';

import { ApiBaseContract } from './base';

export class ApiContractGE extends ApiBaseContract {
  @ApiOptions({ channel: 'contractDeliveryPointSetting.get', capacities: [RoleCapacity.apiContractBasicRead] })
  getPortfolioContracts() {
    return this.get(`/ge/portfolio-management/contracts`);
  }

  @ApiOptions({ channel: 'contractDeliveryPointSetting.get', capacities: [RoleCapacity.apiContractHeaderBasicRead] })
  getContractHeaders(params: ParamsAdapter) {
    return this.get(`/ge/contract/header`, params);
  }

  @ApiOptions({ channel: 'contractSign', interceptErrors: false })
  signContract(contractId: number, params: ParamsAdapter) {
    return this.post(`/ge/contract/${contractId}/sign`, params);
  }

  @ApiOptions({ channel: 'contractSignatureCancel' })
  cancelContractSignature(contractId: number) {
    return this.post(`/ge/contract/${contractId}/cancel-signature`);
  }

  @ApiOptions({ channel: 'contractDeliveryPointSetting.get', capacities: [RoleCapacity.apiContractBasicRead] })
  getContractToNominate(params: ParamsAdapter) {
    return this.get(`/ge/contract/to-nominate`, params);
  }

  @ApiOptions({ channel: 'forecastFavoriteGet', interceptErrors: false })
  getForecastFavorite(params: ParamsAdapter) {
    return this.get(`/ge/customer-volume-forecast/favorite`, params);
  }

  @ApiOptions({ channel: 'forecastFavoriteGet', interceptErrors: false })
  getForecastFavoriteList(params: ParamsAdapter) {
    return this.get(`/ge/customer-volume-forecast/favorite-list`, params);
  }

  @ApiOptions({ channel: 'forecastFavoritePut', interceptErrors: false })
  updateForecastFavorite(params: ParamsAdapter) {
    return this.put(`/ge/customer-volume-forecast/favorite`, params);
  }

  @ApiOptions({ channel: 'forecastFavoriteDelete' })
  deleteForecastFavorite(params: ParamsAdapter) {
    return this.delete(`/ge/customer-volume-forecast/favorite`, params);
  }

  @ApiOptions({ channel: 'transactionConfirmationContacts.get' })
  getTransactionConfirmationContacts(params: ParamsAdapter) {
    return this.get(`/ge/contract/transaction-confirmation-recipients`, params);
  }

  @ApiOptions({ channel: 'transactionConfirmationContacts.post' })
  postTransactionConfirmationContacts(contractId: number, params: ParamsAdapter) {
    return this.post(`/ge/contract/${contractId}/transaction-confirmation-recipients`, params);
  }

  @ApiOptions({ channel: 'transactionConfirmationContacts.post' })
  deleteTransactionConfirmationContacts(contractId: number) {
    return this.delete(`/ge/contract/${contractId}/transaction-confirmation-recipients`);
  }

  @ApiOptions({ interceptErrors: false })
  getClientPriceForecasts(contractId: number, perimeterId: number, params: ParamsAdapter) {
    return this.get(`/ge/contract/${contractId}/perimeter/${perimeterId}/client-price`, params);
  }

  @ApiOptions({ interceptErrors: false })
  getClientCostForecasts(contractId: number, perimeterId: number, params: ParamsAdapter) {
    return this.get(`/ge/contract/${contractId}/perimeter/${perimeterId}/client-cost`, params);
  }

  @ApiOptions({ channel: 'invoice.get' })
  getInvoiceHeader(params: ParamsAdapter) {
    return this.get(`/ge/invoice-header`, params);
  }

  @ApiOptions({
    channel: 'invoiceSimulation.get',
    interceptErrors: false,
    returnedFields: 'total{contract_id,commodity,currency,month,start_date,end_date,vat_excluded_total,vat_included_total, volume,details}',
  })
  getInvoiceSimulation(contractId: number, params: ParamsAdapter) {
    return this.get(`/ge/invoice-simulation/${contractId}`, params);
  }

  @ApiOptions({ channel: 'logisticRegularizationPost' })
  uploadRegularizationExcel(params: ParamsAdapter) {
    return this.post(`/ge/invoice/manual-lines-excel`, params);
  }

  @ApiOptions({ channel: 'contractTransactionMarketExposure' })
  getTransactionMarketExposureByTransactionType(contractId: number, transactionTypeId: number, params: ParamsAdapter) {
    return this.get(`/ge/contract/${contractId}/transaction-type/${transactionTypeId}/market-exposure`, params);
  }

  @ApiOptions({ channel: 'nominationRuleGet', interceptErrors: false })
  getNominationRules(contractId: number) {
    return this.get(`/ge/settings/user-curves/contract/${contractId}`);
  }

  @ApiOptions({ channel: 'nominationRulePut' })
  createOrUpdateNominationRule(contractId: number, params: ParamsAdapter) {
    return this.put(`/ge/settings/user-curves/contract/${contractId}`, params);
  }

  /**
   * Get invoice PDF with waaf option
   */
  @ApiOptions({ channel: 'invoice.pdf', responseType: 'blob' })
  getInvoicePdfWaaf(params: ParamsAdapter) {
    return this.get<Blob>(`/ge/waaf-invoice/pdf`, params);
  }
}
